<div class="about-us-mobile-form overflow-auto pt-3">
  <kl-fpo-over-view-form (closedForm)="ok()"></kl-fpo-over-view-form>
</div>
